import {IComponentController} from "angular";
import './hue-colour-select.parent.component.scss';

export const hueColourSelectControllerBindings = (self) => ['$mdColorPalette', '$mdColors', '$mdColorUtil', self];

export class HueColourSelectParentComponent implements IComponentController {

    protected selectedColourValueChange: (colourHex: string) => void;
    protected selectedColour: string;

    protected palleteColors: string[];

    constructor(private $mdColorPalette: angular.material.IColorPalette,
                private $mdColors: angular.material.IColorService,
                private $mdColorUtil: any) {
        this.palleteColors = Object.keys($mdColorPalette);
    }

    protected updateColorValue = () => {
        if (this.selectedColourValueChange) {
            this.selectedColourValueChange(
                this.getColourHex(
                    this.getColourName(this.selectedColour, '800')
                )
            );
        }
    };

    protected getColourHex = (colour: string): string => {
        return this.$mdColorUtil.rgbaToHex(this.$mdColors.getThemeColor(colour));
    };

    protected getColourHexByNameAndHue = (colour, hue): string => {
        return this.getColourHex(this.getColourName(colour, hue));
    };

    protected getColourHexByName = (colour): string => {
        return this.getColourHex(this.getColourByName(colour));
    };

    protected getColourByName = (colour): string => {
        return this.getColourName(colour, '800');
    };

    protected getColourName = (palletColour: string, hue: string) => {
        return palletColour + "-" + hue;
    };

}